import React, { FC } from 'react'

import ControlPanel from 'src/components/ControlPanel'

const FirstRow: FC = () => {
  return <ControlPanel />
}

export default FirstRow
